var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-data-table',{attrs:{"service-provider":_vm.serviceProvider,"vuex-module":_vm.vuexModule,"header-columns":_vm.filteredHeaderColumns,"query-params":_vm.queryParams,"label":"Company Admins"},scopedSlots:_vm._u([{key:"cell_user",fn:function(ref){
var value = ref.value;
return [_vm._v(_vm._s(value.is_superuser ? "*" : "")+"\n\t\t\t"+_vm._s(value.first_name))]}},{key:"cell_user_email",fn:function(ref){
var value = ref.value;
return [_c('a',{attrs:{"href":("mailto:" + value)}},[_vm._v(_vm._s(value))])]}},{key:"cell_cash_call_approver",fn:function(ref){
var value = ref.value;
var row = ref.row;
return [('Superuser' !== _vm.$user.get().role)?[_vm._v(_vm._s(_vm.capitalizeText(value)))]:_c('base-switch',{attrs:{"id":("cash-call-approver-" + (row.id)),"value":'Active' == value,"onText":"","offText":""},on:{"click":function($event){return _vm.onSwitchCashCallApproverStatus(
            'member',
            row,
            'Active' == value ? 'InActive' : 'Active',
            $event
          )}}})]}},{key:"cell_status",fn:function(ref){
          var value = ref.value;
          var row = ref.row;
return [('Superuser' !== _vm.$user.get().role)?[_vm._v(_vm._s(_vm.capitalizeText(value)))]:_c('base-switch',{attrs:{"id":("status-" + (row.id)),"value":'Active' == value,"onText":"","offText":""},on:{"click":function($event){return _vm.onSwitchStatus(
						'member',
						row,
						'Active' == value ? 'InActive' : 'Active',
						$event
					)}}})]}},{key:"cell_billing_contact",fn:function(ref){
					var value = ref.value;
					var row = ref.row;
return [('Superuser' !== _vm.$user.get().role)?[_vm._v("\n        "+_vm._s(_vm.capitalizeText(value))+"\n      ")]:_c('base-switch',{attrs:{"id":("billing-contact-" + (row.id)),"value":'Active' == value,"onText":"","offText":""},on:{"click":function($event){return _vm.onSwitchBillingContact(row, 'Active' == value ? 'InActive' : 'Active', $event)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }